import React from 'react';
import { bands, stages } from '../data/content';
import { CourtMark } from './icons/HandballMarks';
export function Journey() {
  return <section className="bg-navy-900 px-5 py-16 sm:py-20" data-id="element-159" data-mp="1ip5oghz1dqaw">
      <div className="mx-auto max-w-6xl" data-id="element-160" data-mp="1eols3gmaeqpt">
        <div className="mx-auto max-w-3xl text-center" data-id="element-161" data-mp="1epdmio45eiei">
          <p className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.14em] text-navy-900 sm:text-xs" data-id="element-162" data-mp="19qskcj5c5onf">
            <CourtMark className="h-3 w-auto" data-id="element-163" data-mp="26i4c4frbt8us" />
            Der Aufbau der Sammlung
          </p>
          <h2 className="mt-6 font-display text-3xl font-black leading-tight text-white sm:text-4xl" data-id="element-164" data-mp="22h29rq244gol">
            Vom ersten Ballgefühl{' '}
            <span className="text-gold" data-id="element-165" data-mp="1spoa9ia5vgvg">zum gemeinsamen Spiel.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-166" data-mp="2q4shxngpl27i">
            Drei Altersstufen, je zwei Bände: einer legt die Grundlagen, der
            zweite überträgt sie ins Spiel. Die Kategorien geben eine
            Orientierung – Gruppe, Lernstand und örtliche Bedingungen schätzt du
            selbst ein.
          </p>
        </div>

        <ol className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-167" data-mp="2g4b3ih2j5u4g">
          {stages.map((stage, index) => <li key={stage.age} className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-800 p-6" data-id="element-168" data-mp="2k5wokpp7xepq" data-mpi={index}>
              <div className="flex items-baseline justify-between gap-3" data-id="element-169" data-mp="264kc4o99nv8l">
                <span className="font-display text-4xl font-black leading-none text-white/15" data-id="element-170" data-mp="2b69llzguc0uk">
                  {index + 1}
                </span>
                <span className="rounded-full border border-gold/40 bg-gold/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-gold" data-id="element-171" data-mp="1x7tggcymmiej">
                  {stage.age}
                </span>
              </div>

              <h3 className="mt-5 font-display text-xl font-extrabold leading-snug text-white" data-id="element-172" data-mp="3vktfy68vkg09">
                {stage.headline}
              </h3>
              <p className="mt-1 text-xs font-semibold uppercase tracking-[0.14em] text-white/50" data-id="element-173" data-mp="18e74w5lipt7l">
                {stage.group}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-white/65" data-id="element-174" data-mp="zbo2tnpk3kme">
                {stage.description}
              </p>

              <ul className="mt-auto space-y-2 pt-6" data-id="element-175" data-mp="udwet4s18inh">
                {stage.bandNumbers.map(number => {
              const band = bands.find(b => b.number === number);
              if (!band) return null;
              return <li key={number} className="flex items-start gap-3 rounded-lg bg-navy-700 px-3 py-2.5" data-id="element-176" data-mp="1n3waqe4k2le7">
                      <span className="font-display text-xs font-black text-gold" data-id="element-177" data-mp="1db79ec2pynwl">
                        {band.number}
                      </span>
                      <span className="text-[13px] font-semibold leading-snug text-white/85" data-id="element-178" data-mp="25zuqdvgfqr4c">
                        {band.title}
                      </span>
                    </li>;
            })}
              </ul>
            </li>)}
        </ol>
      </div>
    </section>;
}